import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const usePermissionsState = () => React.useContext(Context) || {}
export const usePermissions = () => usePermissionsState()?.permissions || []
export const usePermission = (profile, name) =>
  usePermissions().find(p => p.name === name && p.profileId === profile.id)

const QUERY = gql`
  query Permissions {
    permissions(sort: { field: ID, type: ASC }, limit: 99999) {
      id
      name
      profileId
      enabled
    }
  }
`

const PermissionsLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} empty={false}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default PermissionsLoader
